/* eslint-disable no-use-before-define */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import { FC } from 'react';
import { Box, Divider, Grid, makeStyles } from '@material-ui/core';
import { editTemplateTitle } from 'src/store/modules/template';
import { useDispatch, useSelector } from 'react-redux';

import { RootState } from 'src/store';
import {
  TEMPLATES_EDITOR_REGARCY,
  TEMPLATES_TRACKING_EDITOR
} from 'src/constants/templates';
import Check from 'src/components/Icon/Check';
import { editButton1, editButton2 } from 'src/store/modules/trackings';
import AboutButtonTooltip from 'src/components/AboutButtonOneTwoTooltip';

const useStyles = makeStyles(() => ({
  wrapper: {
    width: '13.25rem',
    minWidth: '13.25rem',
    height: 'calc(100vh - 3rem)',
    position: 'relative',
    backgroundColor: '#434343'
  },

  title: {
    height: '3rem',
    padding: '0 1rem',
    display: 'flex',
    // flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',

    color: '#fff',
    fontFamily: 'Archivo',
    fontSize: '0.875rem',
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: 'normal',
    backgroundColor: '#434343'
  },
  divider: {
    margin: '0 1rem',
    background: '#646464'
  },

  scroll: {
    height: 'calc(100% - 3.94rem)',
    padding: '1rem',

    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
    overflow: 'scroll',

    scrollbarWidth: 'none',
    scrollbarHeight: 'none',
    '&::-webkit-scrollbar': {
      display: 'none'
    }
  },
  menuWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem'
  },
  slideWrapper: {
    height: '1.5rem',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',

    color: '#fff',
    fontFamily: 'Archivo',
    fontSize: '0.75rem',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '1.18225rem',
    letterSpacing: '0.0225rem',
    backgroundColor: '#888'
  },
  menu: {
    height: '1.5rem',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',

    color: '#fff',
    fontFamily: 'Archivo',
    fontSize: '0.75rem',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '1.18225rem',
    letterSpacing: '0.0225rem'
  },
  iconWrapper: {
    width: '1.25rem',
    height: '1.25rem',

    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',

    borderRadius: 4,
    backgroundColor: '#fff'
  }
}));

const NavLeft: FC = () => {
  const dispatch = useDispatch();
  const classes = useStyles();

  let currentTemplate = useSelector(
    (state: RootState) => state.template.templateTitle
  );

  let currentButton = useSelector(
    (state: RootState) => state.trackings.currentButton
  );
  let bgImage = useSelector((state: RootState) => state.imageUpload.bgImage);
  let text = useSelector((state: RootState) => state.editText.text);
  let btnText = useSelector((state: RootState) => state.buttons.btnText);
  let tracking = useSelector((state: RootState) => state.trackings.tracking);
  let button1 = useSelector((state: RootState) => state.trackings.button1);
  let button2 = useSelector((state: RootState) => state.trackings.button2);
  let btnType = useSelector((state: RootState) => state.buttons.btnType);

  let len =
    bgImage?.multi_background?.length ||
    bgImage?.multi_image?.length ||
    text?.multi_text?.length;

  const checkShow = (type, idx) => {
    const BUTTON = currentButton === 0 ? button1 : button2;
    const isExistType = BUTTON?.hasOwnProperty(type);
    if (isExistType) {
      const isExistValue = BUTTON?.[type]?.indexOf(Number(idx)) !== -1;
      return isExistValue;
    }
    return false;
  };
  const checkShow2 = (type, currentIndex, idx) => {
    const BUTTON = currentButton === 0 ? button1 : button2;
    const isExistType = BUTTON?.hasOwnProperty(type);
    if (isExistType) {
      const isExistValue =
        BUTTON?.[type]?.[currentIndex]?.indexOf(Number(idx)) !== -1;
      return isExistValue;
    }
    return false;
  };

  const editButton = newData => {
    if (currentButton === 0) {
      dispatch(editButton1({ ...button1, ...newData }));
    } else {
      dispatch(editButton2({ ...button2, ...newData }));
    }
  };
  const handleCheck = (type, idx) => {
    const BUTTON = currentButton === 0 ? button1 : button2;

    const isExistType = BUTTON?.hasOwnProperty(type);
    if (isExistType) {
      let newButtons = BUTTON?.[type]?.slice();
      const isExistCheck = checkShow(type, idx);
      if (isExistCheck) {
        const isExistIndex = BUTTON?.[type]?.indexOf(Number(idx));
        newButtons.splice(isExistIndex, 1);
      } else {
        newButtons.push(idx);
      }

      const newButton = JSON.parse(
        `{"${type}": [${newButtons?.map((_: any, idx: number) => {
          const newB = newButtons?.[idx];
          return `${newB}`;
        })}]}`
      );
      editButton(newButton);
    } else {
      const newButton = JSON.parse(`{"${type}": [${idx}]}`);
      editButton(newButton);
    }
  };
  const handleCheck2 = (type, currentIndex, idx) => {
    const BUTTON = currentButton === 0 ? button1 : button2;

    const isExistType = BUTTON?.hasOwnProperty(type);
    if (isExistType) {
      let newButtons = BUTTON?.[type]?.[currentIndex]?.slice();
      const isExistCheck = checkShow2(type, currentIndex, idx);
      if (isExistCheck) {
        const isExistIndex = BUTTON?.[type]?.[currentIndex]?.indexOf(
          Number(idx)
        );
        newButtons.splice(isExistIndex, 1);
      } else {
        newButtons.push(idx);
      }

      let newButtonJson = BUTTON?.[type]?.slice();
      newButtonJson.splice(currentIndex, 1, newButtons);

      const newButton = JSON.parse(
        `{"${type}": [${newButtonJson?.map((buttons: any) => {
          return `[${buttons?.map((button: any) => {
            return `${button}`;
          })}]`;
        })}]}`
      );
      editButton(newButton);
    } else {
      const newButton = JSON.parse(
        `{"${type}": [${tracking?.multi_action_survey?.map(
          (data: any, optionIdx: number) => {
            return currentIndex === optionIdx ? `[${idx}]` : `[]`;
          }
        )}]}`
      );
      editButton(newButton);
    }
  };

  return (
    <Box className={classes.wrapper}>
      <Box className={classes.title}>
        BUTTON LIST
        <AboutButtonTooltip />
      </Box>
      <Divider classes={{ root: classes.divider }} />
      <Box className={classes.scroll}>
        {[...Array(len)]?.map((_: any, idx: number) => {
          return (
            <Box key={idx} className={classes.menuWrapper}>
              <Box className={classes.slideWrapper}>Slide {idx + 1}</Box>
              {TEMPLATES_TRACKING_EDITOR?.[currentTemplate]
                ?.filter(type => {
                  if (currentTemplate === 'CHOICE BUTTON MODAL') {
                    const filterKeys =
                      btnType === 'double'
                        ? ['image_button']
                        : ['image_left_button', 'image_right_button'];
                    return !filterKeys.includes(type);
                  }
                  return true;
                })
                .map((type: any) => {
                  return (
                    TEMPLATES_TRACKING_EDITOR?.[currentTemplate] &&
                    tracking?.[type]?.map((data: any, idx3: number) => {
                      return (
                        idx === idx3 &&
                        (Array.isArray(data) ? (
                          data?.map((data2: any, idx4: number) => {
                            return (
                              <Menu2
                                currentIndex={idx3}
                                idx={idx4}
                                type={type}
                                data={data2}
                                Fn={{ handleCheck2, checkShow2 }}
                              />
                            );
                          })
                        ) : (
                          <Menu
                            idx={idx3}
                            type={type}
                            data={data}
                            Fn={{ handleCheck, checkShow }}
                          />
                        ))
                      );
                    })
                  );
                })}
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};

export default NavLeft;

const Menu2 = ({ currentIndex, idx, type, data, Fn }: any) => {
  const classes = useStyles();

  return (
    <Box key={idx} className={classes.menu}>
      {data}
      <Box
        className={classes.iconWrapper}
        onClick={() => Fn.handleCheck2(type, currentIndex, idx)}
      >
        <Check
          stroke={Fn.checkShow2(type, currentIndex, idx) ? '#000' : '#fff'}
        />
      </Box>
    </Box>
  );
};

const Menu = ({ idx, type, data, Fn }: any) => {
  const classes = useStyles();

  return (
    <Box key={idx} className={classes.menu}>
      {data}
      <Box
        className={classes.iconWrapper}
        onClick={() => Fn.handleCheck(type, idx)}
      >
        <Check stroke={Fn.checkShow(type, idx) ? '#000' : '#fff'} />
      </Box>
    </Box>
  );
};
